import {Injectable} from '@angular/core';
import {OAuthErrorEvent, OAuthService} from 'angular-oauth2-oidc';
import {ClientAccountService} from '../../shared/services/client-account.service';
import {UsersService} from '../../shared/services/users.service';
import { AuthConfigService } from './auth-config.service';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class AuthService {

  private _decodedAccessToken: any;
  private _decodedIDToken: any;
  private _identityClaims: any;
  private readonly errorText = new BehaviorSubject(``);
  getErrorText = this.errorText.asObservable();

  get decodedAccessToken() {
    return this._decodedAccessToken;
  }

  get decodedIDToken() {
    return this._decodedIDToken;
  }

  get identityClaims() {
    return this._identityClaims;
  }

  set identityClaims(value: any) {
    this._identityClaims = value;
  }

  constructor(
    private readonly oauthService: OAuthService,
    private readonly authConfigService: AuthConfigService,
    private clientAccountService: ClientAccountService,
    private usersService: UsersService, 
    private readonly _router: Router
  ) {
      // subscribe to token events
      this.oauthService.events
        .subscribe((event) => {
          if (event.type === 'token_received') {
            this.handleNewToken();
          } else if (event.type === 'logout') {
            this.clientAccountService.clearUnit();
            this.usersService.clearUser();
            //this.oauthService.logOut(true);
          }
          if (event instanceof OAuthErrorEvent) {
            this.errorText.next(event.type.toString());
          }
        });
  }

  // CALLED BY PROVIDER AT START APP
  async initAuth(): Promise<any> {
    return new Promise<void>((resolveFn, rejectFn) => {
      console.log('### - initAuth');
      // setup oauthService
      this.oauthService.configure(this.authConfigService.getConfiguration());
      this.oauthService.setStorage(sessionStorage);

      // continue initializing app or redirect to login-page
      return this.oauthService.loadDiscoveryDocument()
      .then(() => {
        return this.oauthService.tryLogin();
      })
      .then(
        (resolve) => {
          console.log('### - loginOK');
          this.oauthService.setupAutomaticSilentRefresh();
          this.identityClaims = this.oauthService.getIdentityClaims();
          const routes = window.location.href.split('#/',2);
          if (routes.length < 2 || routes[1] === '') {
            this._router.navigate(['dashboard']);
          }
          resolveFn();
        },
        (reject) => {
          console.log('### - loginError');
          this._router.navigate(['login']);
          const queryParams = new URLSearchParams(window.location.search);
          if (queryParams.has('error')) {
            let error = queryParams.get('error');
            if (queryParams.has('error_description')) {
              error = queryParams.get('error_description');
            }
            if(error){
              this.errorText.next(error);
            }
          } else if (typeof reject === 'string'){
            this.errorText.next(reject);
          } else if (typeof reject === 'object'){
            if (reject.type === 'code_error') {
              this.errorText.next(reject.error_description);
            }
          } else {
            this.errorText.next('AUTHENTICATION_ERROR');
          }
          resolveFn();
        });
      /*
      this.oauthService.loadDiscoveryDocumentAndLogin().then(isLoggedIn => {
        if (isLoggedIn) {
          this.oauthService.setupAutomaticSilentRefresh();
          this.identityClaims = this.oauthService.getIdentityClaims();
          resolveFn();
        } else {
          //this.oauthService.initImplicitFlow();
          rejectFn();
        }
      }).catch(err => {
        console.log(err);
      });
      */
    });
  }

  private handleNewToken() {
    this._decodedAccessToken = this.oauthService.getAccessToken();
    this._decodedIDToken = this.oauthService.getIdToken();
  }

  loginStart() {
    console.log('### - loginStart');
    this.oauthService.initLoginFlow();
  }

  logout() {
    console.log('### - logoutStart');
    this.usersService.clearUser();
    this.clientAccountService.clearUnit(true);
    this.oauthService.stopAutomaticRefresh();
    this.oauthService.logOut(true);
    this._router.navigate(['login']);
  }
}
